import React from 'react'
import clsx from 'clsx'
import PropTypes from 'prop-types'
import { FormattedMessage, useIntl } from 'react-intl'

import { makeStyles, Box, Typography } from '@material-ui/core'
import { SELECT_MODE } from 'app/constants/table'

const useStyles = makeStyles((theme) => ({
  root: {
    background: theme.colors['primary-200'],
    width: '100%',
    height: '50px',
    display: 'flex',
    padding: '2rem',
    alignItems: 'center',
  },
}))

const BulkSelectedBox = ({
  selectedCount = 0,
  children,
  className,
  mode = null,
  pagination = {},
}) => {
  const classes = useStyles()
  const { formatMessage } = useIntl()

  // Determine if we should show the box and what count/text to display
  const isSelectAllMode = mode === SELECT_MODE.ALL
  const totalCount = pagination?.total || 0
  const shouldShow = isSelectAllMode ? totalCount > 0 : selectedCount > 0

  if (!shouldShow) {
    return null
  }

  const selectCount = isSelectAllMode ? totalCount : selectedCount
  const formattedSelectCount = selectCount.toLocaleString()
  const selectedLabel = formatMessage({ id: 'selected.label' })

  return (
    <Box className={clsx(classes.root, className)}>
      <Typography className="text-14 font-500 text-grey-400 whitespace-nowrap">
        {formattedSelectCount} {selectedLabel}
      </Typography>
      {children}
    </Box>
  )
}

BulkSelectedBox.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  selectedCount: PropTypes.number,
  mode: PropTypes.string,
  pagination: PropTypes.shape({
    total: PropTypes.number,
    currentPage: PropTypes.number,
    perPage: PropTypes.number,
    lastPage: PropTypes.number,
  }),
}

export default BulkSelectedBox
